import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";

import Layout from "antd/es/layout";
import cn from "classnames";
import { useRouteMatch } from "react-router-dom";

import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

import ReportType from "@app/enum/ReportType";
import Header from "@app/scene/reports/components/common/Header";
import Menu from "@app/scene/reports/components/common/Menu";
import { getTeams, getUsers } from "@app/store/members";
import { RootState } from "@app/store/rootReducer";
import getSelectedTeams from "@app/util/members/getSelectedTeams";

import { getAnalyticIssuerByTabKey } from "../reportsAnalytics";
import { getUserIds } from "../store/selectors";

import BaseScreenProps from "./BaseScreenProps";
import ExportEditNavigation from "./ExportEditNavigation";
import styles from "./ReportScreen.module.scss";

type RouteParams = {
  0: "team" | "user";
  exportId?: string;
  id: string;
};

interface Props {
  children: (props: BaseScreenProps) => React.ReactNode;
  reportType: ReportType;
  teams: Team[];
  userIds?: User["id"][];
  users: User[];
}

const ReportScreen: React.FC<Props> = ({ children, reportType, teams, userIds = [], users }) => {
  const { params } = useRouteMatch<RouteParams>();

  const { exportId } = params;

  const selectedUsers = useMemo(() => {
    return userIds.length > 0 ? users.filter(({ id }) => userIds.includes(id)) : users;
  }, [userIds, users]);
  const selectedTeams = useMemo(() => getSelectedTeams(teams, userIds), [teams, userIds]);

  const reportId = exportId ? parseInt(exportId) : undefined;

  useEffect(() => {
    getAnalyticIssuerByTabKey(reportType).clicked([]);
  }, [reportType]);

  return (
    <Layout className={styles.container}>
      <Header />
      {reportType === ReportType.EXPORT_EDIT && <ExportEditNavigation />}

      <Layout.Content>
        <Layout
          className={cn(styles.nestedContainer, {
            [styles.noPaddingBottom]: reportType === ReportType.WEEKLY_REPORT_CARD,
          })}
        >
          {reportType !== ReportType.EXPORT_EDIT && <Menu />}
          <Layout.Content
            className={cn(styles.nestedContent, {
              [styles.fullWidth]: reportType === ReportType.WEEKLY_REPORT_CARD,
            })}
          >
            {children({ reportId, selectedTeams, selectedUsers })}
          </Layout.Content>
        </Layout>
      </Layout.Content>
    </Layout>
  );
};

const mapStateToProps = (state: RootState) => ({
  teams: getTeams(state),
  userIds: getUserIds(state),
  users: getUsers(state),
});

export default connect(mapStateToProps)(ReportScreen);
